import { IPartnerFinSobRow } from '../../model/types'

import { FULL_YEAR_QUARTER, OVERALL_CATEGORY } from './constants'
import { isActualsFinSobRow } from './isActualsFinSobRow'
import { isRequestedCategoryRow } from './isRequestedCategoryRow'
import { TCategoryRowScope } from './types'

interface IParams {
  rows: IPartnerFinSobRow[]
  selectedFYear: number
  currentFQuarter: number
  category?: string
  categoryRowScope?: TCategoryRowScope
}

/** The two halves the expected exit column is made of, kept apart so each can be summed (and
 *  shown) on its own. */
export interface IExpectedExitRows {
  /** Actuals for the quarters that have closed — before `currentFQuarter`. */
  actuals: IPartnerFinSobRow[]
  /** Plan for the quarter still in progress and any quarters ahead. */
  plan: IPartnerFinSobRow[]
}

/** The rows the expected exit column is made of: this year's quarterly offering totals,
 *  blending actuals for quarters that have closed with plan for the quarter still in
 *  progress and any quarters ahead — never the `FULL_YEAR_QUARTER` sentinel, since this
 *  rolls up the individual quarters itself. `currentFQuarter` itself counts as not yet
 *  closed, so it reads plan rather than actuals. */
export const getExpectedExitRows = ({
  rows,
  selectedFYear,
  currentFQuarter,
  category = OVERALL_CATEGORY,
  categoryRowScope = 'total',
}: IParams): IExpectedExitRows => {
  const quarterRows = rows.filter(
    (row) =>
      row.fYear === selectedFYear &&
      isRequestedCategoryRow(row, category, categoryRowScope) &&
      row.fQuarter !== FULL_YEAR_QUARTER
  )

  return {
    actuals: quarterRows.filter((row) => isActualsFinSobRow(row) && row.fQuarter < currentFQuarter),
    plan: quarterRows.filter((row) => row.isTarget && row.fQuarter >= currentFQuarter),
  }
}
